import React from "react";
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { colors } from "@ippon/shared-components";

interface BackButtonProps {
  /** アイコンのサイズ(px)。 */
  size?: number;
  /** 省略時は navigate(-1) で1つ前のページへ。 */
  onClick?: () => void;
  ariaLabel?: string;
}

/**
 * セクションタイトル左に置く「戻る」ボタン。
 * 装飾なしの左矢印アイコンで、通常はグレー・ホバーで青(primary)。クリックで1つ前へ。
 */
export const BackButton: React.FC<BackButtonProps> = ({
  size = 24,
  onClick,
  ariaLabel = "前のページに戻る",
}) => {
  const navigate = useNavigate();
  return (
    <IconButton
      onClick={onClick ?? (() => navigate(-1))}
      disableRipple
      aria-label={ariaLabel}
      sx={{
        p: 0,
        flexShrink: 0,
        color: colors.text.secondary,
        transition: "color 0.15s ease",
        "&:hover": {
          backgroundColor: "transparent",
          color: colors.primary.main,
        },
      }}
    >
      <ArrowBackIcon sx={{ fontSize: size }} />
    </IconButton>
  );
};

export default BackButton;
